import { thunk } from 'easy-peasy';

import { toPhotoFileName } from '~/utils/file';
import api from '~/services/api';
import { IThunkEditClient } from '../types';

const onEditClient: IThunkEditClient = thunk(async (_, { requestInfo, requestPayload }) => {
  const photo = await toPhotoFileName(requestPayload.photo);
  await api.client.editClient(requestInfo, { ...requestPayload, photo });
});

export default onEditClient;
